import * as React from 'react'
import { PropsWithChildren } from 'react'

import { HighlightedBox, HighlightedBoxColor } from './HighlightedBox'

function getColorForValue(value: number): HighlightedBoxColor {
  if (value <= 10) {
    return HighlightedBoxColor.DarkGreen
  } else if (value <= 20) {
    return HighlightedBoxColor.MediumGreen
  } else if (value <= 30) {
    return HighlightedBoxColor.LightGreen
  } else if (value < 70) {
    return HighlightedBoxColor.Neutral
  } else if (value < 80) {
    return HighlightedBoxColor.LightRed
  } else if (value < 90) {
    return HighlightedBoxColor.MediumRed
  } else {
    return HighlightedBoxColor.DarkRed
  }
}

interface RsiValueProps {
  className?: string
  value?: number | null
}

export function RsiValue({ children, className, value }: PropsWithChildren<RsiValueProps>) {
  if (!Number.isFinite(value)) {
    return null
  }
  return (
    <HighlightedBox className={className} color={getColorForValue(value as number)}>
      {children}
    </HighlightedBox>
  )
}
